import { apiUrl } from '@/api/axios';
import { handleResponseError } from '@/core/utils/handleResponseError';
import { getTranslation } from '@/core/utils/i18nHelper';

export const sendForm = (slice, url, successMessageKey) => (data) => async (dispatch) => {
	const successMessage = getTranslation(successMessageKey);

	// for testing
	// dispatch(slice.actions.formSent(successMessage));

	try {
		const response =  await apiUrl.post(url, data, {
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			}
		});
		dispatch(slice.actions.formSent(successMessage));
		return response;
	} catch (error) {
		handleResponseError(error, (data) => dispatch(slice.actions.setError(data)));
	}
};
